export enum AlertType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}

export interface ToastrAlert {
  type: AlertType;
  message: string;
}
